<script>
  import { Card } from 'attractions'
</script>

<Card outline>
  <div class="command">addTurnCommand(string direction)</div>
  Turns the robot on the playing surface.
  <p>
    The robot will turn in the specified direction. The direction must be either <strong>left</strong> or
    <strong>right</strong>.
  </p>
  <div class="title">Arguments:</div>
  <ul>
    <li>
      <strong>direction</strong> &mdash; A string to represent the direction in which to move the robot.
    </li>
  </ul>
  <div class="title">Constraints:</div>
  <ul>
    <li>The direction must be either <strong>left</strong> or <strong>right</strong>.</li>
  </ul>
  <div class="title">Example:</div>
  <div class="code">
    <pre>
      robot.addTurnCommand("left"); /* Turns the robot to the left */
      robot.addTurnCommand("right"); /* Turns the robot to the right */
    </pre>
  </div>
</Card>

<Card outline>
  <div class="api command">addTurnCommand(int angle)</div>
  Turns the robot on the playing surface.
  <p>
    The robot will turn in the specified angle. The angle is measured in degrees from the horizontal, with positive
    values turning the robot to the right and negative values turning the robot to the left.
  </p>
  <div class="api title">Arguments:</div>
  <ul>
    <li>
      <strong>angle</strong> &mdash; The angle used to move the robot.
    </li>
  </ul>
  <div class="api title">Constraints:</div>
  <ul>
    <li>The angle must be between -180 and 180 degrees.</li>
  </ul>
  <div class="api title">Example:</div>
  <div class="api code">
    <pre>
      robot.addTurnCommand(45); /* Turns the robot 45 degrees to the right */
      robot.addTurnCommand(-90); /* Turns the robot 90 degrees to the left */
    </pre>
  </div>
</Card>
